import { Modal, Button } from "react-bootstrap";
import "./ConfirmModal.scss";

export default function ConfirmModal({
  show,
  handleClose,
  handleConfirm,
  setShowValidation,
  showValidzation,
  loadingEmail,
}) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Valider</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        <div className="icon mb-3">
          <span role="img" aria-label="vacances" className="emoji">
            🏖️
          </span>
        </div>
        <p>
          Vous êtes sur le point de <strong>valider le document</strong>.
          <br />
          Voulez-vous continuer ?
        </p>
        <small className="text-muted">
          Une fois cette action validée, une notification sera envoyée au
          validateur suivant.
        </small>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          Annuler
        </Button>
        <Button
          variant="warning"
          onClick={handleConfirm}
          disabled={loadingEmail}>
          {loadingEmail ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Envoi en cours...
            </>
          ) : (
            "Confirmer"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
